const Debug = require('../util/debug')('session-storage-wrapper');

/**
 * If you´re browsing in private mode in Safari, the session storage will throw an error.
 * This wrapper function takes care of that kind of errors.
 * @param {string} key
 * @param {*} value
 */
export function setInSessionStorage(key, value) {
    if (window.sessionStorage) {
        try {
            sessionStorage[key] = value;
        } catch (e) {
            Debug('Could not save to session storage', e);
        }
    }
}

/**
 * If you´re browsing in private mode in Safari, the session storage will throw an error.
 * This wrapper function takes care of that kind of errors.
 * @param {string} key
 * @param defaultValue {*} If unset
 * @returns {*}
 */
export function getFromSessionStorage(key, defaultValue = null) {
    if (window.sessionStorage) {
        try {
            return sessionStorage[key] || defaultValue;
        } catch (e) {
            Debug('Could not fetch from session storage', e);

            return defaultValue;
        }
    }
}

/**
 * If you´re browsing in private mode in Safari, the session storage will throw an error.
 * This wrapper function takes care of that kind of errors.
 * @param {string} key
 */
export function removeFromSessionStorage(key) {
    if (window.sessionStorage) {
        try {
            sessionStorage.removeItem(key);
        } catch (e) {
            Debug('Could not fetch from session storage', e);
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/util/session-storage-wrapper.js